import { RecordId } from '@stylehaven/components';

export enum ActionResultStatus {
    COMPLETED = 'Completed',
    FAILED = 'Failed'
}

export interface SingleActionResponse {
    RecordId: RecordId;
    Status: ActionResultStatus;
    ErrorMessage?: string;
}

export interface MultipleActionResponse {
    BatchId?: string;
    Executions?: SingleActionResponse[];
}
